import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: 'app-media-info',
    templateUrl: './media-info.component.html',
    styleUrls: ['./media-info.component.scss']
})
export class MediaInfoComponent implements OnInit {
    @Input() dateTime!: any[];

    constructor() { }

    ngOnInit(): void {}
}